require('./bootstrap')

// Import modules...
import { createApp, h } from 'vue'
import {
  App as InertiaApp,
  plugin as InertiaPlugin,
} from '@inertiajs/inertia-vue3'
import { InertiaProgress } from '@inertiajs/progress'
import store from './Store'
import VueHighcharts from 'vue3-highcharts'
import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'
import HighchartsBullet from 'highcharts/modules/bullet'

HighchartsMore(Highcharts)
HighchartsBullet(Highcharts)

const el = document.getElementById('app')
window.app = createApp({
  render: () =>
    h(InertiaApp, {
      initialPage: JSON.parse(el.dataset.page),
      resolveComponent: (name) => require(`./Pages/${name}`).default,
    }),
})
  .mixin({
    methods: {
      route,
      // https://medium.com/@cdruc/displaying-validation-errors-with-inertiajs-and-laravel-9c1b7273a0de
      // error(field, errorBag = 'default') {
      //     if (this.$page.errors) {
      //         if (!this.$page.errors.hasOwnProperty(errorBag)) {
      //             return null;
      //         }
      //         if (this.$page.errors[errorBag].hasOwnProperty(field)) {
      //             return this.$page.errors[errorBag][field][0];
      //         }
      //     }
      //     return null;
      // }
    },
  })
  .use(InertiaPlugin)
  .use(store)
  .use(VueHighcharts)
  .mount(el)

InertiaProgress.init({ color: '#4B5563' })
